module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAA8UlEQVQ4ja1TwQ3CMAw8WAA2gA0oG7ABHQEUKfkyAiPwTaSIjlAmoGxQNigbwARFRga5UVq1Kv4kde3z+exM6rrGGJuOyg4BlDZLpU1Op/DNewEobRIAJYAtgFzElEqbYx8GFDTj+0ok0ZkobYoYGwnwbClCfmJXATh1AWTivvbOfhh4Z6mdFADpQhptogDe2QLAhT93Msg7W7LvEDJo7AH3WLEWe+9sJvwJF2ltgSpRv1+K50DIK4+4IWR0E5U2KWtCTB4AFuL3yzv7A4luIgtHTO5BMnhX4i0EIKV3lsa3ZxZkN55IdwtD7L+PabABeAN061QhzcKbxwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/phone.png
// module id = REca
// module chunks = 1